const translationMap = {
  "sv-se": {
    translationMap: [
      { translationName: "Back to Home", translation: "Tillbaka till start" },
      { translationName: "Login Here", translation: "Logga in här" },
      { translationName: "Search", translation: "sökfunktionen" },
      { translationName: "All Categories", translation: "Alla kategorier" },
      { translationName: "View Profile", translation: "Se profil" },
      { translationName: "Welcome", translation: "Välkommen" },
      { translationName: "Logout", translation: "Logga ut" },
      { translationName: "Filter", translation: "Filtrera" },
      { translationName: "All", translation: "Alla " },
      { translationName: "all", translation: "Alla " },
      { translationName: "Technical", translation: "Tekniskt" },
      { translationName: "Clinical", translation: "Kliniskt" },
      { translationName: "New", translation: "Nyhet" },
      { translationName: "All Products", translation: "Alla produkter" },
      { translationName: "Copyright", translation: "upphovsrätt" },
      {
        translationName: "Connect with Customer Service",
        translation: "Ta kontakt med kundtjänst",
      },
      { translationName: "Contact", translation: "Kontakt" },
      {
        translationName: "All rights reserved.",
        translation: "Alla rättigheter förbehållna.",
      },
      { translationName: "Products", translation: "produkter" },
      { translationName: "Documents", translation: "Dokument" },
      {
        translationName: "ResMed Internal only",
        translation: "ResMed endast internt",
      },
      { translationName: "Multiple Documents", translation: "Flera dokument" },
      {
        translationName: "Select an option",
        translation: "Välj ett alternativ",
      },
      {
        translationName: "sleep device",
        translation: "sömnapnéapparater",
      },
      {
        translationName: "ventilators",
        translation: "ventilatorer",
      },
      {
        translationName: "mask",
        translation: "masker",
      },
      {
        translationName: "oral-appliance",
        translation: "antiapnéskena",
      },
      {
        translationName: "diagnostics",
        translation: "diagnostisk",
      },
      {
        translationName: "accessory",
        translation: "apparattillbehör",
      },
      {
        translationName: "software-and-data-management",
        translation: "datahantering",
      },
      {
        translationName: "Displaying",
        translation: "Visar",
      },
      {
        translationName: "of",
        translation: "av",
      },
      {
        translationName: "result(s)",
        translation: "resultat",
      },
      {
        translationName: "results",
        translation: "resultat",
      },
      {
        translationName: "result",
        translation: "resultat",
      },
      { translationName: "Find out more", translation: "Mer information" },
      {
        translationName: "Login to",
        translation: "Logga in",
      },
      {
        translationName: "Awaiting approval",
        translation: "Väntar Godkännande",
      },
      {
        translationName: "Quality Assistant",
        translation: "Kvalitetsassistent",
      },
      {
        translationName: "View Pdf",
        translation: "för att visa PDF-fil",
      },
      {
        translationName: "View Video",
        translation: "för att visa video",
      },
      {
        translationName: "Connect with ResMed",
        translation: "Anslut till ResMed",
      },
      { translationName: "Home", translation: "Hemma" },
      { translationName: "Support", translation: "Hjälp" },
      { translationName: "intro", translation: "intro" },
      { translationName: "Use", translation: "Användning" },
      { translationName: "Filter by", translation: "Filtrera efter" },
      { translationName: "type", translation: "typ" },
      { translationName: "Access denied", translation: "Åtkomst nekad" },
      {
        translationName:
          "This content is only available in selected countries. Please contact customer service if you need further assistance.",
        translation:
          "Det här innehållet är endast tillgängligt i vissa länder. Kontakta kundtjänst om du behöver mer hjälp.",
      },
      { translationName: "OK", translation: "OK" },
      {
        translationName: "Download Software",
        translation: "för att ladda ned mjukvara",
      },
      { translationName: "DISCONTINUED", translation: "Utgått" },
      {
        translationName: "Discontinued Product(s)",
        translation: "Produkt(er) som har utgått",
      },
      { translationName: "View More", translation: "Visa mer" },
      { translationName: "View less", translation: "Visa mindre" },
      {
        translationName:
          "January, february, march, april, may, june, july, august, september, october, november, december",
        translation:
          "Januari, februari, mars, april, maj, juni, juli, augusti, september, oktober, november, december",
      },
      {
        translationName: "What can we help you find?",
        translation: "Vad letar du efter?",
      },
      {
        translationName: "Results for",
        translation: "resultat för",
      },
      {
        translationName: "An error occurred loading your search results",
        translation: "Ett fel uppstod när dina sökresultat skulle laddas",
      },
      {
        translationName: "Retry",
        translation: "Försök igen",
      },
      {
        translationName: "Search tips to consider:",
        translation: "Söktips att tänka på:",
      },
      {
        translationName: "Double check spelling",
        translation: "Dubbelkolla stavningen",
      },
      {
        translationName:
          "Try using a less specific search term or different keyword",
        translation:
          "Försök att använda en mindre specifik sökterm eller ett annat sökord",
      },
      {
        translationName:
          "You don't have access permissions to view the PDF's for this region/category/products",
        translation:
          "Du har inte åtkomstbehörighet för att se PDF-filerna för denna region/kategori/produkter",
      },
      {
        translationName: "'X' discontinued product(s)",
        translation: "'X' produkt(er) har utgått",
      },
      {
        translationName: "Invaild User for Downloading",
        translation: "Ogiltig användare för nedladdning",
      }
    ],
  },
  "nb-no": {
    translationMap: [
      {
        translationName: "Back to Home",
        translation: "Tilbake til startsiden",
      },
      { translationName: "Login Here", translation: "Logg på her" },
      { translationName: "Search", translation: "Søk" },
      { translationName: "All categories", translation: "Alle kategorier" },
      { translationName: "View Profile", translation: "Vis profil" },
      { translationName: "Welcome", translation: "Velkommen" },
      { translationName: "Logout", translation: "Logg av" },
      { translationName: "Filter", translation: "Filter" },
      { translationName: "All", translation: "Alle " },
      { translationName: "Technical", translation: "Teknisk" },
      { translationName: "Clinical", translation: "Klinisk" },
      { translationName: "New", translation: "Nyhet" },
      { translationName: "Copyright", translation: "opphavsrett" },
      {
        translationName: "Connect with Customer Service",
        translation: "Ta kontakt med kundeservice",
      },
      { translationName: "Contact", translation: "Kontakt" },
      {
        translationName: "All rights reserved.",
        translation: "Alle rettigheter forbeholdt.",
      },
      {
        translationName: "Login to",
        translation: "Logg på",
      },
      {
        translationName: "Awaiting approval",
        translation: "Venter på godkjenning",
      },
      {
        translationName: "Connect with ResMed",
        translation: "Koble til ResMed",
      },
      { translationName: "Products", translation: "Produkter" },
      { translationName: "Documents", translation: "Dokumenter" },
      {
        translationName: "ResMed Internal only",
        translation: "Kun ResMed Internal",
      },
      {
        translationName: "Multiple Documents",
        translation: "Flere dokumenter",
      },
      {
        translationName: "Select an option",
        translation: "Velg et alternativ",
      },
      {
        translationName: "sleep device",
        translation: "søvnapnéapparater",
      },
      {
        translationName: "ventilators",
        translation: "ventilasjonsapparater",
      },
      {
        translationName: "mask",
        translation: "masker",
      },
      {
        translationName: "oral-appliance",
        translation: "dental-søvnbehandling",
      },
      {
        translationName: "diagnostics",
        translation: "diagnostikk",
      },
      {
        translationName: "accessory",
        translation: "tilbehør",
      },
      {
        translationName: "Filter by device type",
        translation: "Filtrer etter apparattype",
      },
      {
        translationName: "Quality Assistant",
        translation: "Kvalitetsassistent",
      },
      { translationName: "All Products", translation: "Alle produkter" },
      {
        translationName: "Displaying",
        translation: "Viser",
      },
      {
        translationName: "of",
        translation: "av",
      },
      {
        translationName: "result(s)",
        translation: "resultat(er)",
      },
      {
        translationName: "results",
        translation: "resultater",
      },
      {
        translationName: "result",
        translation: "resultat",
      },
      { translationName: "Find out more", translation: "Finn ut mer" },
      { translationName: "Login to View Pdf", translation: "Logg på Vis PDF" },
      {
        translationName: "Login to View Video",
        translation: "Logg på Vis video",
      },
      { translationName: "Home", translation: "Hjem" },
      { translationName: "Support", translation: "Hjelp" },
      { translationName: "intro", translation: "intro" },
      { translationName: "Use", translation: "Bruk" },
      {
        translationName: "Filter by mask type",
        translation: "Filtrer etter masketype",
      },
      { translationName: "Select your", translation: "Velg" },
      { translationName: "Filter by", translation: "Filtrer etter" },
      { translationName: "type", translation: "type" },
      { translationName: "Access denied", translation: "Tilgang nektet" },
      {
        translationName:
          "This content is only available in selected countries. Please contact customer service if you need further assistance.",
        translation:
          "Dette innholdet er bare tilgjengelig i utvalgte land. Kontakt kundeservice hvis du trenger ytterligere hjelp.",
      },
      {
        translationName: "Login to Download Software",
        translation: "Logg på Last ned programvare",
      },
      { translationName: "DISCONTINUED", translation: "Utgått" },
      {
        translationName: "Discontinued Product(s)",
        translation: "Utgått(e) produkt(er)",
      },
      { translationName: "View More", translation: "Vis mer" },
      { translationName: "View less", translation: "Vis mindre" },
      {
        translationName:
          "January, february, march, april, may, june, july, august, september, october, november, december",
        translation:
          "Januar, februar, mars, april, mai, juni, juli, august, september, oktober, november, desember",
      },
      {
        translationName: "What can we help you find?",
        translation: "Hva kan vi hjelpe deg å finne?",
      },
      {
        translationName: "Results for",
        translation: "Resultater for",
      },
      {
        translationName: "An error occurred loading your search results",
        translation: "Det oppsto en feil ved lasting av søkeresultatene",
      },
      {
        translationName: "Retry",
        translation: "Prøv på nytt",
      },
      {
        translationName: "Search tips to consider:",
        translation: "Søketips du bør vurdere:",
      },
      {
        translationName: "Double check spelling",
        translation: "Dobbeltsjekk stavemåten",
      },
      {
        translationName:
          "Try using a less specific search term or different keyword",
        translation:
          "Prøv å bruke et mindre spesifikt søkeord eller et annet søkeord",
      },
      {
        translationName:
          "You don't have access permissions to view the PDF's for this region/category/products",
        translation:
          "Du har ikke tilgangsrettigheter til å se PDF-ene for denne regionen/kategorien/produktene",
      },
      {
        translationName: "'X' discontinued product(s)",
        translation: "«X» utgått(e) produkt(er)",
      },
      {
        translationName: "Invaild User for Downloading",
        translation: "Ugyldig bruker for nedlasting",
      }
    ],
  },
  "ja-jp": {
    translationMap: [
      { translationName: "Back to Home", translation: "ホームに戻る" },
      { translationName: "Login Here", translation: "こちらからログイン" },
      { translationName: "Search", translation: "検索" },
      { translationName: "All categories", translation: "全てのカテゴリー" },
      { translationName: "View all", translation: "すべて表示" },
      { translationName: "View Profile", translation: "プロフィールを見る" },
      { translationName: "Welcome", translation: "ようこそ" },
      { translationName: "Logout", translation: "ログアウト" },
      { translationName: "Filter", translation: "絞り込み" },
      { translationName: "All", translation: "すべて" },
      { translationName: "Technical", translation: "テクニカル" },
      { translationName: "Clinical", translation: "クリニカル" },
      { translationName: "Copyright", translation: "著作権" },
      {
        translationName: "Connect with Customer Service",
        translation: "カスタマー サービスに接続する",
      },
      {
        translationName: "Connect with ResMed",
        translation: "レスメドとつながる",
      },
      { translationName: "Contact", translation: "コンタクト" },
      {
        translationName: "All rights reserved.",
        translation: "All rights reserved.",
      },
      {
        translationName: "Login to",
        translation: "ログインして",
      },
      {
        translationName: "Awaiting approval",
        translation: "承認待ち",
      },
      { translationName: "New", translation: "最新" },
      { translationName: "Products", translation: "製品" },
      { translationName: "Documents", translation: "ドキュメント" },
      {
        translationName: "ResMed Internal only",
        translation: "ResMed 内部のみ",
      },
      {
        translationName: "Multiple Documents",
        translation: "複数のドキュメント",
      },
      {
        translationName: "Select an option",
        translation: "選択肢一つを選択してください",
      },
      {
        translationName: "sleep device",
        translation: "CPAP装置",
      },
      {
        translationName: "ventilators",
        translation: "人工呼吸器",
      },
      {
        translationName: "mask",
        translation: "マスク",
      },
      {
        translationName: "accessory",
        translation: "アクセサリ",
      },
      {
        translationName: "software-and-data-management",
        translation: "ソフトウェアとデータ管理",
      },
      {
        translationName: "Filter by device type",
        translation: "装置のタイプで絞込み",
      },
      { translationName: "All Products", translation: "すべての製品" },
      { translationName: "Quality Assistant", translation: "品質アシスタント" },
      {
        translationName: "Displaying",
        translation: "件中",
      },
      {
        translationName: "of",
        translation: "～",
      },
      {
        translationName: "result(s)",
        translation: "件を表示",
      },
      {
        translationName: "results",
        translation: "件を表示",
      },
      { translationName: "Find out more", translation: "詳細について" },
      {
        translationName: "Login to View Pdf",
        translation: "ログインしてPDFを表示",
      },
      {
        translationName: "Login to View Video",
        translation: "ログインして動画を再生",
      },
      // { translationName: "Home", translation: "ホームページ" },
      { translationName: "Support", translation: "サポート" },
      { translationName: "intro", translation: "はじめに" },
      { translationName: "Use", translation: "使用" },
      {
        translationName: "Filter by mask type",
        translation: "マスクのタイプで絞り込み",
      },
      { translationName: "Filter by", translation: "絞り込み" },
      { translationName: "type", translation: "種類" },
      {
        translationName: "Access denied",
        translation: "アクセスが拒否されました",
      },
      {
        translationName:
          "This content is only available in selected countries. Please contact customer service if you need further assistance.",
        translation:
          "こちらのコンテンツは、一部の国でのみ利用可能です。ご不明な点がございましたら、カスタマーサービスまでお問い合わせください。",
      },
      { translationName: "OK", translation: "OK" },
      {
        translationName: "Login to Download Software",
        translation: "ログインしてソフトウェアをダウンロード",
      },
      { translationName: "DISCONTINUED", translation: "取扱終了" },
      {
        translationName: "Discontinued Product(s)",
        translation: "取扱終了の製品",
      },
      { translationName: "View More", translation: "続きを見る" },
      { translationName: "View less", translation: "非表示にする" },
      {
        translationName:
          "January, february, march, april, may, june, july, august, september, october, november, december",
        translation:
          "1月、2月、3月、4月、5月、6月、7月、8月、9月、10月、11月、12月",
      },
      {
        translationName: "What can we help you find?",
        translation: "何をお探しですか？",
      },
      {
        translationName: "Results for",
        translation: "の結果",
      },
      {
        translationName: "Result",
        translation: "結果",
      },
      {
        translationName: "An error occurred loading your search results",
        translation: "検索結果の読み込み中にエラーが発生しました",
      },
      {
        translationName: "Retry",
        translation: "リトライ",
      },
      {
        translationName: "Search tips to consider:",
        translation: "考慮すべき検索のヒント:",
      },
      {
        translationName: "Double check spelling",
        translation: "スペルをダブルチェック",
      },
      {
        translationName:
          "Try using a less specific search term or different keyword",
        translation:
          "より具体的でない検索用語または別のキーワードを使用してみてください",
      },
      {
        translationName:
          "You don't have access permissions to view the PDF's for this region/category/products",
        translation:
          "この地域/カテゴリ/製品の PDF を表示するアクセス権限がありません",
      },
      {
        translationName: "'X' discontinued product(s)",
        translation: "「X」ー取扱終了の製品",
      },
      {
        translationName: "Invaild User for Downloading",
        translation: "ダウンロードに無効なユーザー",
      }
    ],
  },
  "pt-br": {
    translationMap: [
      { translationName: "View Profile", translation: "Visualizar perfil" },
      { translationName: "Login Here", translation: "Entrar aqui" },
      { translationName: "Welcome", translation: "Bem vindo" },
      { translationName: "Logout", translation: "Sair" },
      { translationName: "Search", translation: "Procurar" },
      { translationName: "All categories", translation: "Todas as categorias" },
      {
        translationName: "ResMed Employee Login",
        translation: "Entrar associado ResMed",
      },
      {
        translationName: "Field Safety Action",
        translation: "Ação de segurança de campo",
      },
      { translationName: "Technical Content", translation: "Conteúdo técnico" },
      { translationName: "Sleep device", translation: "Sömnapnéapparater" },
      { translationName: "Ventilators", translation: "Ventilatorer" },
      { translationName: "Oxygen", translation: "Oxigênio" },
      { translationName: "myAir Support", translation: "myAir Support" },
      {
        translationName: "Recently updated",
        translation: "Atualizações recentes",
      },
      { translationName: "Filter", translation: "Filtros" },
      { translationName: "TECHNICAL", translation: "Técnico" },
      { translationName: "CLINICAL", translation: "Clínico" },
      { translationName: "Technical", translation: "Técnico" },
      { translationName: "Clinical", translation: "Clínico" },
      { translationName: "All", translation: "Todos" },
      { translationName: "Approved", translation: "Aprovado" },
      { translationName: "Pending", translation: "Pendente" },
      { translationName: "Rejected", translation: "Rejeitado" },
      { translationName: "Clinical Content", translation: "Conteúdo Clínico" },
      {
        translationName: "Commercial Content",
        translation: "Conteúdo Comercial",
      },
      { translationName: "Technical Content", translation: "Conteúdo Técnico" },
      {
        translationName: "Invaild User for Downloading",
        translation: "Usuário inválido para download",
      }
    ],
  },
  "es-xl": {
    translationMap: [
      { translationName: "View Profile", translation: "Ver perfil" },
      { translationName: "Login Here", translation: "Ingresarse aquí" },
      { translationName: "Welcome", translation: "Bienvenido" },
      { translationName: "Logout", translation: "Salir" },
      { translationName: "Search", translation: "Buscar" },
      {
        translationName: "All categories",
        translation: "Todas las categorias",
      },
      {
        translationName: "ResMed Employee Login",
        translation: "Entrar associado ResMed",
      },
      {
        translationName: "Field Safety Action",
        translation: "Ação de segurança de campo",
      },
      {
        translationName: "Sleep device",
        translation: "Dispositivos para dormir",
      },
      { translationName: "Ventilators", translation: "Ventiladores" },
      { translationName: "Oxygen", translation: "Oxígeno" },
      { translationName: "myAir Support", translation: "Soporte myAir" },
      {
        translationName: "Recently updated",
        translation: "Actualizaciones recientes",
      },
      { translationName: "Filter", translation: "Filtrar" },
      { translationName: "TECHNICAL", translation: "Técnico" },
      { translationName: "CLINICAL", translation: "Clínico" },
      { translationName: "Technical", translation: "Técnico" },
      { translationName: "Clinical", translation: "Clínico" },
      { translationName: "All", translation: "Todos" },
      { translationName: "Approved", translation: "Aprobado" },
      { translationName: "Pending", translation: "Pendiente" },
      { translationName: "Rejected", translation: "Rechazado" },
      { translationName: "Clinical Content", translation: "Contenido clínico" },
      {
        translationName: "Commercial Content",
        translation: "Contenido comercial",
      },
      {
        translationName: "Technical Content",
        translation: "Contenido Técnico",
      },
      {
        translationName: "Invaild User for Downloading",
        translation: "Usuario inválida para descargar",
      }
    ],
  },
  "fi-fi": {
    translationMap: [
      {
        translationName: "Back to Home",
        translation: "Takaisin alkuun",
      },
      {
        translationName: "Login Here",
        translation: "Kirjaudu täällä",
      },
      {
        translationName: "Philips Recall",
        translation: "Philipsin takaisinveto",
      },
      {
        translationName: "Search",
        translation: "Hae",
      },
      {
        translationName: "All categories",
        translation: "Kaikki luokat",
      },
      {
        translationName: "View all",
        translation: "Näytä kaikki",
      },
      {
        translationName: "ResMed myAir app",
        translation: "ResMed myAir-sovellus",
      },
      {
        translationName: "Your myAir score",
        translation: "Omat myAir-pisteet",
      },
      {
        translationName:
          "Wake up to results. Your myAir score makes tracking your progress simple.",
        translation:
          "Tulokset heti aamulla. myAir-pisteiden ansiosta edistymistä on helppo seurata.",
      },
      {
        translationName: "Daily sleep data",
        translation: "Päivittäiset unitiedot",
      },
      {
        translationName:
          "Get more details. The app tracks four key therapy metrics so you stay informed.",
        translation:
          "Lisää tietoa. Sovellus seuraa neljää keskeistä hoidon mittaria.",
      },
      {
        translationName: "Personalized coaching tips",
        translation: "Henkilökohtaiset valmennusvihjeet",
      },
      {
        translationName:
          "Increase your comfort. With myAir, you'll learn how to improve therapy for better sleep.",
        translation:
          "Paranna käyttömukavuutta. myAir-sovellus opettaa, miten voit parantaa hoitoa ja nukkua paremmin.",
      },
      {
        translationName: "Sign in to MyAir app",
        translation: "Kirjaudu myAir-sovellukseen",
      },
      {
        translationName: "Get in on Google play",
        translation: "Lataa sovellus Google Playsta",
      },
      {
        translationName: "Download on the App store",
        translation: "Lataa App Storesta",
      },
      {
        translationName: "Product information",
        translation: "Tuotetiedot",
      },
      {
        translationName: "Looking for a product guide?",
        translation: "Etsitkö tuoteopasta?",
      },
      {
        translationName: "Get help with your ResMed product today.",
        translation: "Täältä saat ResMed-tuotetta koskevia ohjeita.",
      },
      {
        translationName: "Find Your product",
        translation: "Etsi tuote",
      },
      {
        translationName: "Glossary",
        translation: "Sanasto",
      },
      {
        translationName:
          "The ResMed Glossary contains vocabulary frequently used to talk about our products and features on our site and aspects of our service.",
        translation:
          "ResMedin sanastossa on sivustolla käytettäviä termejä, jotka liittyvät tuotteisiin, ominaisuuksiin ja ResMedin palveluihin.",
      },
      {
        translationName: "View Profile",
        translation: "Näytä profiili",
      },
      {
        translationName: "Welcome",
        translation: "Tervetuloa",
      },
      {
        translationName: "Logout",
        translation: "Kirjaudu ulos",
      },
      {
        translationName: "Recently updated",
        translation: "Äskettäin päivitetty",
      },
      {
        translationName: "Filter",
        translation: "Suodatin",
      },
      {
        translationName: "All",
        translation: "Kaikki",
      },
      {
        translationName: "Technical",
        translation: "Tekninen",
      },
      {
        translationName: "Clinical",
        translation: "Kliininen",
      },
      {
        translationName: "New",
        translation: "Uusi",
      },
      {
        translationName: "Select your device",
        translation: "Valitse laite",
      },
      {
        translationName: "Filter by device type",
        translation: "Suodata laitetyypin mukaan",
      },
      {
        translationName: "All Products",
        translation: "Kaikki tuotteet",
      },
      {
        translationName: "Displaying",
        translation: "Näytetään",
      },
      {
        translationName: "Find out more",
        translation: "Lisätietoja",
      },
      {
        translationName: "Resources",
        translation: "Resurssit",
      },
      {
        translationName: "Descrption",
        translation: "Kuvaus",
      },
      {
        translationName: "Helpful Documents",
        translation: "Hyödyllisiä asiakirjoja",
      },
      {
        translationName: "For Healthcare Professionals",
        translation: "Terveydenhuollon ammattilaisille",
      },
      {
        translationName: "Healthcare Professionals",
        translation: "Terveydenhuollon ammattilaiset",
      },
      {
        translationName:
          "Restricted resources for healthcare professionals. Log in to your account to access clinical papers, product detailed information, webinars, PDFs to download, and more.",
        translation:
          "Vain terveydenhuollon ammattilaisille tarkoitetut resurssit. Kirjautumalla sisään saat käyttöösi kliiniset julkaisut, yksityiskohtaiset tuotetiedot, verkkoseminaarit, ladattavat PDF-tiedostot yms.",
      },
      {
        translationName: "Service Manuals",
        translation: "Huolto-oppaat",
      },
      {
        translationName: "Technical Notes",
        translation: "Tekniset huomautukset",
      },
      {
        translationName: "Service Software",
        translation: "Huolto-ohjelmisto",
      },
      {
        translationName: "Software Upgrades",
        translation: "Ohjelmistopäivitykset",
      },
      {
        translationName: "View PDF",
        translation: "Näytä PDF",
      },
      {
        translationName: "Download Software",
        translation: "Lataa ohjelmisto",
      },
      {
        translationName: "View Video",
        translation: "Näytä video",
      },
      {
        translationName: "Login to View Pdf",
        translation: "Kirjaudu sisään ja katso PDF",
      },
      {
        translationName: "Login to View Video",
        translation: "Kirjaudu sisään ja katso video",
      },
      {
        translationName: "What can we help you find?",
        translation: "Mitä voimme auttaa löytämään?",
      },
      {
        translationName: "Home",
        translation: "Alkuun",
      },
      {
        translationName: "Support",
        translation: "Tuki",
      },
      {
        translationName: "intro",
        translation: "Johdanto",
      },
      {
        translationName: "Use",
        translation: "Käytä",
      },
      {
        translationName: "Select your attachment or accessory",
        translation: "Valitse lisävaruste",
      },
      {
        translationName: "Select category to filter",
        translation: "Valitse suodatettava luokka",
      },
      {
        translationName: "Select product type",
        translation: "Valitse tuotetyyppi",
      },
      {
        translationName: "Select your mask",
        translation: "Valitse maski",
      },
      {
        translationName: "Filter by mask type",
        translation: "Suodata maskityypin mukaan",
      },
      {
        translationName: "Select your",
        translation: "Valitse oma",
      },
      {
        translationName: "Filter by",
        translation: "Suodata",
      },
      {
        translationName: "type",
        translation: "tyypin mukaan",
      },
      {
        translationName: "Oxygen support documents",
        translation: "Happitukea koskevat asiakirjat",
      },
      {
        translationName: "Access denied",
        translation: "Pääsy kielletty",
      },
      {
        translationName:
          "This content is only available in selected countries. Please contact customer service if you need further assistance.",
        translation:
          "Tämä sisältö on käytettävissä vain tietyissä maissa. Ota yhteyttä asiakaspalveluun, jos tarvitset apua.",
      },
      {
        translationName: "OK",
        translation: "OK",
      },
      {
        translationName: "Login to Download Software",
        translation: "Kirjaudu sisään ja lataa ohjelmisto",
      },
      {
        translationName: "Login to",
        translation: "Kirjaudu sisään ja",
      },
      {
        translationName: "How-to videos",
        translation: "Opetusvideot",
      },
      {
        translationName: "Videos",
        translation: "Videot",
      },
      {
        translationName: "Discontinued",
        translation: "Poistettu valikoimista",
      },
      {
        translationName: "Discontinued Product(s)",
        translation: "Valikoimista poistetut tuotteet",
      },
      {
        translationName: "View More",
        translation: "Näytä lisää",
      },
      {
        translationName: "View less",
        translation: "Näytä vähemmän",
      },
      {
        translationName: "Product Support",
        translation: "Tuotetuki",
      },
      {
        translationName:
          "Direct your patients to these pages for help with their ResMed product.",
        translation:
          "Ohjaa potilaat etsimään ResMed-tuotetukea näiltä sivuilta.",
      },
      {
        translationName: "Read More",
        translation: "Lue lisää",
      },
      {
        translationName:
          "January, february, march, april, may, june, july, august, september, october, november, december",
        translation:
          "Tammikuu, helmikuu, maaliskuu, huhtikuu, toukokuu, kesäkuu, heinäkuu, elokuu, syyskuu, lokakuu, marraskuu, joulukuu",
      },
      {
        translationName: "'X' discontinued product(s)",
        translation: "'X' valikoimista poistettua tuotetta",
      },
      {
        translationName: "ResMed UK",
        translation: "ResMed UK",
      },
      {
        translationName:
          "On this site you will find everything you need for the use, servicing and maintenance of your ResMed device or accessory, as well as user guides and further information related to our digital health solutions. Select from the categories below to find your product.",
        translation:
          "Tällä sivustolla on ResMed-laitteen tai -lisävarusteen käyttöön, huoltoon ja ylläpitoon tarvittavat tiedot. Sivustolla on myös käyttöoppaita ja lisätietoa digitaalisista terveyssovelluksista. Etsi tuote valitsemalla jokin seuraavista luokista.",
      },
      {
        translationName: "Information and sales",
        translation: "Tiedot ja myynti",
      },
      {
        translationName: "Product support",
        translation: "Tuotetuki",
      },
      {
        translationName:
          "Do you have questions about your ResMed product? Visit product support using the link below to access information related to the use and maintenance of your device, as well as information on how to use our apps.",
        translation:
          "Onko sinulla kysyttävää ResMedin tuotteesta? Siirry tuotetukeen napsauttamalla seuraavaa linkkiä. Siellä on tietoa laitteen käytöstä ja ylläpidosta sekä sovellusten käytöstä.",
      },
      {
        translationName: "Go to product support",
        translation: "Siirry tuotetukeen",
      },
      {
        translationName: "Product support",
        translation: "Tuotetuki",
      },
      {
        translationName:
          "Visit product support using the link below for immediate access to our repository of clinical guides and other documents related to your ResMed device, accessory or digital health solution.",
        translation:
          "Siirry tuotetukeen napsauttamalla seuraavaa linkkiä. Siellä on kliinisiä oppaita ja muita ResMedin laitteisiin, lisävarusteisiin ja digitaalisiin terveyssovelluksiin liittyviä asiakirjoja.",
      },
      {
        translationName: "Go to product support",
        translation: "Siirry tuotetukeen",
      },
      {
        translationName: "Product guides and support",
        translation: "Tuoteoppaat ja -tuki",
      },
      {
        translationName: "All documents (product support)",
        translation: "Kaikki asiakirjat (tuotetuki)",
      },
      {
        translationName: "Quality Assistant",
        translation: "Laatuassistentti",
      },
      {
        translationName: "Privacy policy",
        translation: "Tietosuojaseloste",
      },
      {
        translationName: "About us",
        translation: "Tietoa ResMedistä",
      },
      {
        translationName: "Connect",
        translation: "Ota yhteyttä",
      },
      {
        translationName: "Contact Us",
        translation: "Ota yhteyttä",
      },
      {
        translationName: "All rights reserved.",
        translation: "Kaikki oikeudet pidätetään.",
      },
      {
        translationName: "result(s)",
        translation: "tulosta",
      },
      {
        translationName: "ResMed product support | Find support for yours",
        translation: "ResMedin tuotetuki | Tukea tuotteelle",
      },
      {
        translationName:
          "On this site you will find everything you need for the use, servicing and maintenance of your ResMed device or accessory, as well as user guides and further information related to our digital health solutions.",
        translation:
          "Tällä sivustolla on ResMed-laitteen tai -lisävarusteen käyttöön, huoltoon ja ylläpitoon tarvittavat tiedot. Sivustolla on myös käyttöoppaita ja lisätietoa digitaalisista terveyssovelluksista.",
      },
      {
        translationName:
          "On this site you will find everything you need for the use, servicing and maintenance of your ResMed device or accessory, as well as user guides and further information related to our digital health solutions. Select from the categories below to find your product.",
        translation:
          "Tällä sivustolla on ResMed-laitteen tai -lisävarusteen käyttöön, huoltoon ja ylläpitoon tarvittavat tiedot. Sivustolla on myös käyttöoppaita ja lisätietoa digitaalisista terveyssovelluksista. Etsi tuote valitsemalla jokin seuraavista luokista.",
      },
      {
        translationName:
          "ResMed's myAir app allows patients to track their nightly sleep data, receive tailored coaching, and access motivational advice and self-help tools.",
        translation:
          "ResMedin myAir-sovelluksen avulla potilaat voivat seurata yöllisiä unitietojaan, saada räätälöityä valmennusta ja käyttää motivoivia neuvoja ja itseaputyökaluja.",
      },
      {
        translationName: "Sort By",
        translation: "Lajittele",
      },
      {
        translationName: "Latest",
        translation: "Uusin",
      },
      {
        translationName: "Oldest",
        translation: "Vanhin",
      },
      {
        translationName: "A to Z",
        translation: "A-Z",
      },
      {
        translationName: "Z to A",
        translation: "Z-A",
      },
      {
        translationName: "Products",
        translation: "Tuotteet",
      },
      {
        translationName: "Results for",
        translation: "Tulokset for",
      },
      {
        translationName: "Results",
        translation: "Tulokset",
      },
      {
        translationName: "Result",
        translation: "tulos",
      },
      {
        translationName: "Documents",
        translation: "Asiakirjat",
      },
      {
        translationName: "Search tips to consider:",
        translation: "Huomioitavia hakuvinkkejä:",
      },
      {
        translationName: "Double check spelling",
        translation: "Tarkista oikeinkirjoitus kahdesti",
      },
      {
        translationName:
          "Try using a less specific search term or different keyword",
        translation:
          "Yritä käyttää vähemmän tarkkaa hakusanaa tai eri avainsanaa.",
      },
      {
        translationName: "Invaild User for Downloading",
        translation: "Virheellinen käyttäjä lataamista varten",
      }
    ],
  },
};



export function getTranslation(translation, region) {
  try {
    if (translationMap[region]) {
      const transMap = translationMap[region].translationMap;
      const findCat = transMap.find(
        (item) =>
          item.translationName.toLowerCase() === translation.toLowerCase()
      );
      return findCat ? findCat.translation : translation;
    } else {
      return translation;
    }
  } catch (error) {
    console.log(error);
  }
}
